import FilterPool from "../classes/filter/filterPool";
import RangeFilter from "../classes/filter/rangeFilter";
import TagFilter from "../classes/filter/tagFilter";
import AlphabeticProductSorter from "../classes/sort/alphabeticProductSorter";
import PriceSorter from "../classes/sort/priceSorter";
import RelevanceSorter from "../classes/sort/relevanceSorter";
import SortPool from "../classes/sort/sortPool";
import "../range-slider/src/js/rSlider";

export default function InitProductSelection() {
	const productSelectionContainer = document.querySelector(".product-selector-container");
	if (!productSelectionContainer) return;

	setupSorter();
	setupFilters();
}

function createSlider(array, datasetName, step, filterPool) {
	const values = array.map((card) => parseInt(card.dataset[datasetName])).sort((a, b) => a - b);
	const valueRange = {
		min: Math.floor(values[0]),
		max: Math.ceil(values[values.length - 1]),
	};

	const rangeFilter = new RangeFilter(datasetName, valueRange);

	filterPool.registerFilter(rangeFilter);

	const slider = new rSlider({
		target: `#${datasetName}Slider`,
		values: valueRange,
		step: step,
		range: true,
		labels: false,
		scale: false,
		onChange: (values) => {
			let splitValues = values.split(",");
			rangeFilter.update({
				min: parseInt(splitValues[0]),
				max: parseInt(splitValues[1]),
			});
			filterPool.update();
		},
	});

	return slider;
}

function setupSorter() {
	const productCardsSortPool = new SortPool(document.querySelector(".product-selector-container .product-cards-container"));

	const relevanceSorter = new RelevanceSorter();
	const priceSorter = new PriceSorter();
	const alphabeticSorter = new AlphabeticProductSorter();

	const productSortSelect = document.querySelector('.product-selector-container select[name="sort_by"]');
	productSortSelect.addEventListener("change", (event) => {
		switch (event.target.value) {
			case "price_asc":
				priceSorter.setOrder("asc");
				productCardsSortPool.setSorter(priceSorter);
				break;
			case "price_desc":
				priceSorter.setOrder("desc");
				productCardsSortPool.setSorter(priceSorter);
				break;
			case "alpha_asc":
				alphabeticSorter.setOrder("asc");
				productCardsSortPool.setSorter(alphabeticSorter);
				break;
			case "alpha_desc":
				alphabeticSorter.setOrder("desc");
				productCardsSortPool.setSorter(alphabeticSorter);
				break;
			case "relevance":
			default:
				productCardsSortPool.setSorter(relevanceSorter);
				break;
		}
	});
}

function setupFilters() {
	const productCards = Array.prototype.slice.call(document.querySelectorAll(".product-selector-container .card.product"));
	const productCardsFilterPool = new FilterPool(productCards);

	createSlider(productCards, "price", 50, productCardsFilterPool);
	createSlider(productCards, "uploadRate", 50, productCardsFilterPool);
	createSlider(productCards, "downloadRate", 50, productCardsFilterPool);

	const filterButtonWrappers = document.querySelectorAll(".filter-buttons");
	if (filterButtonWrappers.length === 0) return;

	filterButtonWrappers.forEach((filterButtonWrapper) => {
        const filterButtonsLabel = filterButtonWrapper.dataset.filterButtons;
		const filterButtons = filterButtonWrapper.querySelectorAll("button[data-filter-type]");
		if (filterButtons.length === 0) return;

		const filter = new TagFilter(toCamelCase("filter-" + filterButtons[0].dataset.filterName));
		productCardsFilterPool.registerFilter(filter);

		filterButtons.forEach((filterButton) => {
			const filterName = filterButton.dataset.filterName;
			const filterType = filterButton.dataset.filterType;

			filterButton.addEventListener("click", (event) => {
				event.preventDefault();

				filterButton.setAttribute("aria-pressed", !(filterButton.getAttribute("aria-pressed") === "true"));

				const pressedFilterButtons = Array.prototype.slice.call(
					filterButtonWrapper.querySelectorAll(`.filter-buttons button[data-filter-type][aria-pressed="true"]`)
				);
				const values = pressedFilterButtons.map((button) => button.dataset["filterType"]);

				filter.update(values);
				productCardsFilterPool.update();
			});
		});
	});
}

function toCamelCase(str) {
	return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
}
